'use strict';

import {getLogger} from 'loglevel';
var $ = require('jquery'),
  _ = require('underscore'),
  Masonry = require('masonry'),
  loaderTemplate = require('../../tmpl/client/loader.hbs'),
  loaderErrorTemplate = require('../../tmpl/client/loading-error.hbs'),
  TabbedContentView = require('./TabbedContentView'),
  config = require('../config'),
  utilities = require('../utilities');

const log = getLogger('AjaxTabbedContentView');

let AjaxTabbedContentView = TabbedContentView.extend({

  initialize: function() {
    _.bindAll(this, 'onAjaxSuccess', 'onAjaxFail');
    AjaxTabbedContentView.__super__.initialize.apply(this, arguments);

    this.$content = this.$('.TabbedContent-content');
    this.updateMasonry();
  },

  /* --------------------
  Ajax tabbed content methods
  ---------------------*/
  switchTab: function(href) {
    var promise = $.ajax(href, {
      dataType: 'html',
      data: utilities.addCustIpToDataObject({}),
      handleErrorLocally: true //stop global error in errorHandler
    });

    this.$content.html(loaderTemplate);

    promise.done(this.onAjaxSuccess);
    promise.fail(this.onAjaxFail);
  },

  onAjaxSuccess: function(res) {
    var self = this;
    this.$content.removeClass(config.classes.isActive).html(res);
    this.updateMasonry();
    setTimeout(function() {
    // abit hacky but works.
      self.$content.addClass(config.classes.isActive);
    }, 250);
  },

  onAjaxFail: function(xhr, status, msg) {
    this.$content.html(loaderErrorTemplate);
    log.error('Error loading component: ' + status + ' - ' + msg);
  },

  updateMasonry: function() {
    var masonryWrapper = this.$content.find('.Masonry-grid')[0];

    if (!masonryWrapper) return;
    if (this.masonry) {
      this.masonry.destroy();
    }
    this.masonry = new Masonry(masonryWrapper, {
      columnWidth: '.Masonry-gridSizer',
      itemSelector: '.Masonry-item'
    });
  }

});

module.exports = AjaxTabbedContentView;



// WEBPACK FOOTER //
// ./assets/js/components/AjaxTabbedContentView.js